"use client";
import React from "react";
import { breakpointM, breakpointL, breakpointXl } from "@ingka/variables";
if (!breakpointM || !breakpointL || !breakpointXl)
  throw Error(
    "Undefined essential design tokens! Check breakpoint references at @ingka/variables"
  );
const mediaRules = {};
const createRules = () => {
  if (mediaRules.small) return;
  mediaRules.small = window.matchMedia(`(min-width: ${breakpointM})`);
  mediaRules.medium = window.matchMedia(`(min-width: ${breakpointL})`);
  mediaRules.large = window.matchMedia(`(min-width: ${breakpointXl})`);
  mediaRules.all = [mediaRules.small, mediaRules.medium, mediaRules.large];
};
const cleanUpOnDestroy = () => {
  mediaRules.all.length = 0;
  delete mediaRules.all;
  Object.keys(mediaRules).map((key) => delete mediaRules[key]);
};
const stateSetters = [];
const getMediaWidth = () => {
  let breakpoint;
  if (mediaRules.large.matches) breakpoint = mediaWidth.XLARGE;
  else if (mediaRules.medium.matches) breakpoint = mediaWidth.LARGE;
  else if (mediaRules.small.matches) breakpoint = mediaWidth.MEDIUM;
  else breakpoint = mediaWidth.SMALL;
  return breakpoint;
};
const bpIndex = (bp) => breakpointsOrder.indexOf(bp);
const signalBreakpointChange = () => {
  let breakpoint = getMediaWidth();
  stateSetters.forEach(
    ({ current: { breakpointStateSetter, triggerPoints } }) => breakpointStateSetter((previousBreakpoint) => {
      if (triggerPoints.find(
        (triggerpoint) => bpIndex(previousBreakpoint) < bpIndex(triggerpoint) !== bpIndex(breakpoint) < bpIndex(triggerpoint)
      ))
        return breakpoint;
      return previousBreakpoint;
    })
  );
};
const addBreakpointListeners = () => {
  mediaRules.all.forEach(
    (rule) => mediaRules.small.addEventListener ? rule.addEventListener("change", signalBreakpointChange) : rule.addListener(signalBreakpointChange)
    // Safari v13 Fallback
  );
};
const removeBreakpointListeners = () => {
  mediaRules.all.forEach(
    (rule) => mediaRules.small.removeEventListener ? rule.removeEventListener("change", signalBreakpointChange) : rule.removeListener(signalBreakpointChange)
    // Safari v13 Fallback
  );
};
const useBreakpoint = (...triggerPoints) => {
  const [currentBreakpoint, setCurrentBreakpoint] = React.useState();
  const config = React.useRef();
  React.useEffect(() => {
    config.current = {
      breakpointStateSetter: setCurrentBreakpoint,
      triggerPoints
    };
    if (triggerPoints.length) {
      stateSetters.push(config);
      if (stateSetters.length === 1) {
        createRules();
        addBreakpointListeners();
      }
      setCurrentBreakpoint(getMediaWidth());
    }
    return () => {
      if (stateSetters.indexOf(config) > -1)
        stateSetters.splice(stateSetters.indexOf(config), 1);
      if (stateSetters.length === 0) {
        removeBreakpointListeners();
        cleanUpOnDestroy();
      }
    };
  }, triggerPoints);
  return currentBreakpoint;
};
const mediaWidth = {
  SMALL: "sm",
  MEDIUM: "md",
  LARGE: "lg",
  XLARGE: "xl"
};
const breakpointsOrder = [
  mediaWidth.SMALL,
  mediaWidth.MEDIUM,
  mediaWidth.LARGE,
  mediaWidth.XLARGE
];
var useBreakpoints_default = useBreakpoint;
export {
  useBreakpoints_default as default,
  mediaWidth
};
